module.exports = __webpack_public_path__ + "img/duty3.8f101c5d.jpg";